export default {
  alfaCoins: []
}
